const requestHistoricalRecordSearch = 'REQUEST_HISTORICAL_RECORD_SEARCH';
const receiveHistoricalRecordSearch = 'RECEIVE_HISTORICAL_RECORD_SEARCH';

const requestUsaStates = 'REQUEST_USASTATES';
const receiveUsaStates = 'RECEIVE_USASTATES';

const requestScrapers = 'REQUEST_SCRAPERS';
const receiveScrapers = 'RECEIVE_SCRAPERS';

const requestSourceTypes = 'REQUEST_SOURCETYPES';
const receiveSourceTypes = 'RECEIVE_SOURCETYPES';

const initialState = { historicalRecordSearchData: [], usaStates: [], scrapers: [], sourceTypes: [], isLoading: false };

export const actionCreators = {
    requestHistoricalRecordSearch: (states, scrapers, sourceTypes, numRecords, startDate, endDate) => async (dispatch, getState) =>
        new Promise(async function (resolve, reject) {
            if (getState().isLoading) {
                // Don't issue a duplicate request (already loading the requested data)
                return;
            }

            dispatch({ type: requestHistoricalRecordSearch });
            const url = `api/HistoricalRecordSearch/GetHistoricalRecords?states=${states}&scrapers=${scrapers}&sourceTypes=${sourceTypes}&numRecords=${numRecords}&searchStart=${startDate}&searchEnd=${endDate}`;
            let fetchData = {
                method: 'POST',
                body: {},
                headers: new Headers({ 'content-type': 'application/json' })
            }
            const response = await fetch(url, fetchData);
            const historicalRecordSearchData = await response.json();

            dispatch({ type: receiveHistoricalRecordSearch, historicalRecordSearchData });
            resolve(historicalRecordSearchData);
        }), 

    requestUsaStates: () => async (dispatch, getState) =>
        new Promise(async function (resolve, reject) {
            if (getState().isLoading) {
                // Don't issue a duplicate request (already loading the requested data)
                return;
            }

            dispatch({ type: requestUsaStates });
            const url = `api/HistoricalRecordSearch/GetStates`;
            let fetchData = {
                method: 'GET',
                headers: new Headers({ 'content-type': 'application/json' })
            }
            const response = await fetch(url, fetchData);
            const usaStates = await response.json();

            dispatch({ type: receiveUsaStates, usaStates });
            resolve(usaStates);
        }),

    requestScrapers: () => async (dispatch, getState) =>
        new Promise(async function (resolve, reject) {
            if (getState().isLoading) {
                // Don't issue a duplicate request (already loading the requested data)
                return;
            }

            dispatch({ type: requestScrapers });
            const url = `api/HistoricalRecordSearch/GetScrapers`;
            let fetchData = {
                method: 'GET',
                headers: new Headers({ 'content-type': 'application/json' })
            }
            const response = await fetch(url, fetchData);
            const scrapers = await response.json();

            dispatch({ type: receiveScrapers, scrapers });
            resolve(scrapers);
        }), 

    requestSourceTypes: () => async (dispatch, getState) =>
        new Promise(async function (resolve, reject) {
            if (getState().isLoading) {
                // Don't issue a duplicate request (already loading the requested data)
                return;
            }

            dispatch({ type: requestSourceTypes });
            const url = `api/HistoricalRecordSearch/GetSourceTypes`;
            let fetchData = {
                method: 'GET',
                headers: new Headers({ 'content-type': 'application/json' })
            }
            const response = await fetch(url, fetchData);
            const sourceTypes = await response.json();

            dispatch({ type: receiveSourceTypes, sourceTypes });
            resolve(sourceTypes);
        }), 
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestHistoricalRecordSearch
        || action.type === requestUsaStates
        || action.type === requestScrapers
        || action.type === requestSourceTypes) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveHistoricalRecordSearch
        || action.type === receiveUsaStates
        || action.type === receiveScrapers
        || action.type === receiveSourceTypes) {
        return {
            ...state,
            ...action,
            isLoading: false
        };
    }

    return state;
};
